<template>
  <b-menu-item
    :active="
      buffer === 'all-actions' ||
      buffer === 'transition-review' ||
      buffer === 'transition-maps'
    "
    :expanded="
      buffer === 'all-actions' ||
      buffer === 'transition-review' ||
      buffer === 'transition-maps'
    "
    @click="
      transitionStore.canAddActions
        ? activate('all-actions')
        : activate('transition-maps')
    "
  >
    <template slot="label" slot-scope="props">
      <b-icon icon="lightbulb-o"></b-icon>
      {{ $t('transition') }}
      <b-icon
        class="is-pulled-right"
        :icon="props.expanded ? 'caret-down' : 'caret-up'"
      >
      </b-icon>
    </template>

    <b-tooltip
      :label="$t('compTransitionAdminUserMenu.tooltip-actions')"
      type="is-black"
      multilined
      style="width: 100%"
      :active="!transitionStore.canAddActions"
    >
      <b-menu-item
        :active="buffer === 'all-actions'"
        @click="activate('all-actions')"
        :disabled="!transitionStore.canAddActions"
      >
        <template slot="label">
          <b-icon icon="cog"></b-icon>
          {{ $t('compTransitionAdminUserMenu.all-actions') }}
        </template>
      </b-menu-item>
    </b-tooltip>

    <b-menu-item
      :active="buffer === 'transition-maps'"
      @click="activate('transition-maps')"
    >
      <template slot="label">
        <b-icon icon="hubzilla"></b-icon>
        {{ $t('compTransitionAdminUserMenu.transition-maps') }}
      </template>
    </b-menu-item>

    <b-menu-item
      v-if="transitionStore.isReviewer"
      :active="buffer === 'transition-review'"
      @click="activate('transition-review')"
    >
      <template slot="label">
        <b-icon icon="check"></b-icon>
        {{ $t('compTransitionAdminUserMenu.moderation') }}
      </template>
    </b-menu-item>
  </b-menu-item>
</template>

<script>
import { useAdminStore } from '@/stores/admin.js'
import { useTransitionStore } from '@/stores/transition.js'

export default {
  name: 'UserMenu',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  setup () {
    const adminStore = useAdminStore()
    const transitionStore = useTransitionStore()
    return { adminStore, transitionStore }
  },
  data () {
    return {
      buffer: this.value
    }
  },
  watch: {
    value: function () {
      this.buffer = this.value
    }
  },
  methods: {
    activate: function (val) {
      this.buffer = val
      this.$emit('input', this.buffer)
    }
  }
}
</script>
